import React from "react";
import "./lessonCards.scss";

const lessons = [
  {
    title: "Dobre praktyki tworzenia kopii zapasowych",
    subtitle: "fragment lekcji",
    videoSrc: "https://www.youtube.com/embed/0rxZmno3lNo",
  },

  {
    title: "Przekierowanie folderów",
    subtitle: "fragment lekcji",
    videoSrc: "https://www.youtube.com/embed/XkdRuAlHR2Q",
  },
];

const LessonCards = () => {
  return (
    <div className="l-examples">
      <h2 className="addEffect">Przykładowe lekcje</h2>
      <div className="card-group">
        {lessons.map((lesson, index) => (
          <div key={index} className="card">
            <div className="card-body">
              <h4>{lesson.title}</h4>
              <div className="x-subtitle">{lesson.subtitle}</div>
              <div className="ratio">
                <iframe
                  src={lesson.videoSrc}
                  allowFullScreen
                  title="lesson-video"
                ></iframe>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LessonCards;
